var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-video-history-new__video-section-wrapper",class:{
    'grid-1': _vm.gridNum === 1,
    'grid-2': _vm.gridNum === 2,
    'grid-4': _vm.gridNum === 4,
    'grid-6': _vm.gridNum === 6,
    'grid-8': _vm.gridNum === 8,
    'grid-9': _vm.gridNum === 9,
    'grid-16': _vm.gridNum === 16,
  }},[(!_vm.refreshVideoChannels)?[_vm._l((_vm.normalizedChannels),function(channel){return _c('VideoItem',{directives:[{name:"show",rawName:"v-show",value:(_vm.calculatedVideoChannels.includes(channel)),expression:"calculatedVideoChannels.includes(channel)"}],key:`video-channel-${channel}`,ref:`videoItemRef-${channel}`,refInFor:true,attrs:{"channel":channel,"state":_vm.mapWebviewStatePerChannel[channel] ?? '',"imei":_vm.imei},on:{"clickPlay":_vm.clickPlay,"togglePaused":_vm.togglePaused}})}),_vm._l((_vm.calculatedGridEmpty),function(n){return _c('NoVideo',{key:`no-video-${n}`,attrs:{"label":_vm.calculatedVideoChannels.length > 0
          ? _vm.$t('trackVideo.state.noVideo')
          : _vm.$t('videoHistory.selectCameraFirst')}})})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }